import React from 'react';
import PropTypes from 'prop-types';

const Button = ({
  onClick,
  type = 'button',
  name,
  dataTest,
  icon = null,
  label = null,
  className,
  disabled = false
}) => {
  return (
    <button
      type={type}
      id={name}
      name={name}
      data-testid={dataTest}
      className={className}
      onClick={onClick}
      disabled={disabled}
    >
      {icon}
      {label}
    </button>
  );
};

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  dataTest: PropTypes.string.isRequired,
  icon: PropTypes.node,
  label: PropTypes.string,
  className: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

export default Button;
